// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__nwH_a","boxTitle":"Qualiphy_boxTitle__3XJW0","box":"Qualiphy_box__2CJRb","toggleWrap":"Qualiphy_toggleWrap__1yqt4"};